import React from 'react';
import { Switch, Route } from 'react-router-dom';
import TicketCreation from './TicketCreation/TicketCreationContainer';
import TicketList from './TicketList';
import TicketDetails from './Details';
import LearningCenter from './LearningCenter/LearningCenterContainer';
import PortalGuideContainer from './LearningCenter/PortalGuide/PortalGuideContainer';
import VideoContainer from './LearningCenter/Video/VideoContainer';

const Routes = (): React.JSX.Element => (
  <Switch>
    <Route exact path="/tickets">
      <TicketList />
    </Route>
    <Route exact path="/tickets-create">
      <TicketCreation />
    </Route>
    <Route exact path="/tickets/create">
      <TicketCreation />
    </Route>
    <Route path="/tickets/:id">
      <TicketDetails />
    </Route>
    <Route exact path="/learning-centre/pdf-guide" component={PortalGuideContainer} />
    <Route exact path="/learning-centre/video-tutorials" component={VideoContainer} />
    <Route exact path="/learning-centre" component={LearningCenter} />
  </Switch>
);

export default Routes;
